/**
 * Hook for fetching delayed tasks for the dashboard.
 * @module hooks
 */

import { dashboardService } from '@/services/api';
import type { DelayedTasksData } from '@/services/api/dashboardService';
import { useDashboardQuery } from './useDashboardQuery';

const FETCHER = () => dashboardService.getDelayedTasks();

export function useDashboardDelayedTasks() {
  const { data, isLoading, error, refresh } =
    useDashboardQuery<DelayedTasksData>(
      FETCHER,
      'Failed to fetch delayed tasks'
    );
  return {
    delayedTasks: data?.tasks ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    error,
    refresh,
  };
}
